import { createStore } from 'vuex';

export default createStore({
  state: {
    userRole: null,
    checkedItems: [], // Store the list of checked in/out items here
    installPromptAvailable: false, // Track availability of the "Add to Home Screen" prompt
  },
  mutations: {
    // Existing mutations
    ADD_ITEM(state, item) {
      const existingItem = state.checkedItems.find((i) => i.itemID === item.itemID);
      if (existingItem) {
        // Update quantity if item already exists (add new quantity to existing)
        existingItem.quantity += item.quantity; // Increment the existing quantity
      } else {
        // Add new item if it doesn't exist
        state.checkedItems.push({
          itemID: item.itemID,
          name: item.name,
          quantity: item.quantity,
          imageUrl: item.imageUrl,
          action: item.action,
        });
      }
    },
    REMOVE_ITEM(state, itemId) {
      // eslint-disable-next-line no-param-reassign
      state.checkedItems = state.checkedItems.filter((item) => item.itemID !== itemId);
    },
    RESET_CHECKED_ITEMS(state) {
      // eslint-disable-next-line no-param-reassign
      state.checkedItems = []; // Reset the checkedItems to an empty array
    },

    // New mutation to set the install prompt availability
    SET_INSTALL_PROMPT_AVAILABLE(state, isAvailable) {
      // eslint-disable-next-line no-param-reassign
      state.installPromptAvailable = isAvailable;
    },
    SET_USER_ROLE(state, role) {
      // eslint-disable-next-line no-param-reassign
      state.userRole = role;
    },
  },
  actions: {
    // Existing actions
    addItem({ commit }, item) {
      commit('ADD_ITEM', item); // Call the ADD_ITEM mutation
    },
    removeItem({ commit }, itemId) {
      commit('REMOVE_ITEM', itemId); // Call the REMOVE_ITEM mutation
    },
    resetCheckedItems({ commit }) {
      commit('RESET_CHECKED_ITEMS'); // Call the RESET_CHECKED_ITEMS mutation
    },
    setUserRole({ commit }, role) {
      commit('SET_USER_ROLE', role); // Commit the mutation to set userRole
    },
    // New action to update install prompt availability
    setInstallPromptAvailable({ commit }, isAvailable) {
      commit('SET_INSTALL_PROMPT_AVAILABLE', isAvailable);
    },
  },
  getters: {
    userRole: (state) => state.userRole,
    getCheckedItems: (state) => state.checkedItems,
    isInstallPromptAvailable: (state) => state.installPromptAvailable,
  },
});
